<template>
  <section v-if="undefined !== content" class="description-block">
    <div id="description" class="ui-anchor" />
    <div class="description-block__text-w" :class="{ hidden: !isShown }">
      <div ref="textRef" class="ui-rich-text" v-html="content" />
      <div
        v-if="textHeight >= textVisibleHeight && !isShown"
        class="description-block__text-blur"
      />
    </div>
    <button
      v-if="textHeight >= textVisibleHeight"
      class="go-to"
      :class="{ isShown }"
      @click="isShown = !isShown"
    >
      <span>
        {{
          isShown
            ? _T("@Product hide all description")
            : _T("@Product show all description")
        }}
      </span>
      <img
        src="@/assets/icons/nav-arrow-down.svg"
        alt="arrow down"
        loading="lazy"
      />
    </button>
  </section>
</template>

<script setup>
const props = defineProps({
  content: { type: [String, undefined], required: false },
});

const textRef = ref(null);
const isShown = ref(false);
const textVisibleHeight = 300;

const { height: textHeight } = useElementSize(textRef, {
  height: 0,
});

const calcTextMaxHeight = () => {
  if (textHeight.value < textVisibleHeight) {
    return textHeight.value;
  }

  return textVisibleHeight;
};
</script>

<style lang="scss" scoped>
.ui-anchor {
  --height-header: 56px;
  --local-pad: 16px;
}

.description-block {
  &__text-w {
    position: relative;
    height: auto;

    overflow: hidden;

    &.hidden {
      height: calc(v-bind("calcTextMaxHeight()") * 1px);
    }
  }

  &__text-blur {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    margin: 0;
    padding: 30px 0;

    background-image: linear-gradient(to bottom, transparent, white);
  }
}
</style>
